<template>
  <div class="home">
    <b-row>
      <b-col cols="12">
        <h3>L'Assistant V</h3>
        <p>Créer votre plan de salle de bain facilement et rapidement</p>
        <router-link to="/soumissions/create/">
          <button class="btn viewBtn">Créer un nouveau plan</button>
        </router-link>
        <br />ou
        <br />
        <router-link to="/inscription/">
          <button class="btn viewBtn">Inscrivez-vous</button>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
Validator.localize("fr");

export default {
  name: "Home",
  data() {
    return {
      width: 30,
      height: 30
    };
  },
  methods: {
    CheckSessionID: function() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          name: "Soumissions"
        });
      } else {
        var soumission_UID = localStorage.getItem("soumissionUID");

        if (soumission_UID) {
          this.$router.push({
            name: "EditSoumission",
            params: { sid: soumission_UID }
          });
        }
      }
    }
  },
  mounted() {
    this.CheckSessionID();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  text-align: center;
  width: 40%;
  padding: 10vh 10% 10vh 0;
  margin: 0 auto;
}
.home h3 {
  font-size: 3rem;
}
.home p {
  font-size: 1.3rem;
}
@media (max-width: 1199px){
    .home{
        width:50%;
        padding:10vh 10%
    }
}
@media (max-width: 800px){
    .home{
        width:60%;
        padding:10vh 5%
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue